import React from 'react';
import PropTypes from 'prop-types';
import { history } from './../../../configuration/store';

import './footer.css';

class FooterMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        const { aboutLink, blogLink, partnersLink } = this.props;
        return (
            <div className="footer-menu">
                <span onClick={aboutLink}>About</span>
                <span onClick={blogLink}>Blog</span>
                <span onClick={partnersLink}>Partners</span>
            </div>
        );
    }
}

FooterMenu.defaultProps = {
    aboutLink: () => history.push('/about'),
    blogLink: () => history.push('/'),
    partnersLink: () => history.push('/')
};

FooterMenu.propTypes = {
    aboutLink: PropTypes.func,
    blogLink: PropTypes.func,
    partnersLink: PropTypes.func
};

export default FooterMenu;



// WEBPACK FOOTER //
// ./src/components/menus/footer/index.jsx